import { useMemo } from "react";

import { PlainTooltip, Type } from "@similarweb/ui-components";

import AxisLine from "app/components/RankingAxis/AxisLine/AxisLine";
import { AxisLineWrapper } from "app/components/RankingAxis/styles";
import { TooltipGlobalStyle } from "app/components/RankingAxis/Tooltip/styles";
import type { Axis } from "app/components/RankingAxis/types";

import { getAxisPositions } from "../helpers/getAxisPositions";
import { StyledItemIcon, StyledRankingAxisWrapper, AxisDot } from "../StyledComponents";

import Tooltip from "./Tooltip";

type AxisSchema = {
    data: Axis[];
    format: string;
    tooltipValueTitle: string;
    prefix?: string;
    lineBackgroundColor?: string;
    decimal?: number;
};

const RankingAxis = ({ data, format, tooltipValueTitle, prefix, lineBackgroundColor, decimal }: AxisSchema) => {
    const axisPositions = useMemo(() => getAxisPositions(data, format, prefix, decimal), [data, format]);

    return (
        <StyledRankingAxisWrapper>
            <TooltipGlobalStyle />
            <AxisLineWrapper>
                {axisPositions?.positions?.length
                    ? axisPositions.positions.map((item, index) => (
                          <PlainTooltip
                              key={`${index}-${item.name}`}
                              variation="white"
                              maxWidth={350}
                              tooltipContent={
                                  <Tooltip
                                      data={item}
                                      format={format}
                                      tooltipValueTitle={tooltipValueTitle}
                                      prefix={prefix}
                                      decimal={decimal}
                                  />
                              }
                          >
                              <AxisDot position={item?.position}>
                                  <StyledItemIcon
                                      iconSrc={item?.image}
                                      iconType={Type.Website}
                                  />
                              </AxisDot>
                          </PlainTooltip>
                      ))
                    : null}
                <AxisLine
                    axisPositions={axisPositions}
                    lineBackgroundColor={lineBackgroundColor}
                />
            </AxisLineWrapper>
        </StyledRankingAxisWrapper>
    );
};

export default RankingAxis;
